export default "__VITE_ASSET__DLXAnFjo__"